import {ReactNode} from 'react';
import {useEventGiftingClassifiedCategory} from '~/CreateFabricInvitation/routes/EventGifting/useEventGiftingClassifiedCategory';
import {ResponsivePanel} from '~library/organisms/ResponsivePanel';

import './RegistryOverlay.sass';

interface RegistryOverlayProps {
  closeOverlay: () => void;
  isOpen: boolean;
  children: ReactNode;
}

export const RegistryOverlay = ({closeOverlay, children, isOpen}: RegistryOverlayProps) => {
  const {isWeddingEvent, isBabyEvent} = useEventGiftingClassifiedCategory();

  let title = 'Add a wishlist';

  if (isWeddingEvent || isBabyEvent) {
    title = 'Add a registry or wishlist';
  }

  return (
    <ResponsivePanel
      isOpen={isOpen}
      onClose={closeOverlay}
      title={title}
      modalId="registry-overlay"
      showCover
      renderMobileViewAs="bottom-sheet"
      hideHeaderDivider
    >
      <div className="registry-overlay">{children}</div>
    </ResponsivePanel>
  );
};
